import { useAtom } from "jotai";
import { filter, first, noop } from "lodash";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Option } from "space-monad";
import { Select } from "../../../components/forms/select";
import { useAllConfigurations } from "../../../store/participations/queries";
import { selectedLaunch } from "./atoms";

export const useConfigurationState = () => {
  const configurations = useAllConfigurations();
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language.replaceAll("-", "_");

  return useMemo(
    () =>
      Option(configurations)
        .filter((x) => x.isSuccess)
        .map((x) => x.data)
        .map((data) =>
          data.content.map((c) => ({
            id: c.id,
            launchName: c.configuration.launchName[currentLanguage],
          }))
        )
        .map((x) => filter(x, (c) => c.launchName !== null)),
    [configurations, currentLanguage]
  );
};

export const SelectorWrapper: FC<{
  data: {
    id: string;
    launchName: string;
  }[];
}> = ({ data }) => {
  const [selected, setSelected] = useAtom(selectedLaunch);
  return (
    <Select
      fullWidth
      label="Select Referrer"
      value={selected?.id}
      onChange={(e: any) => {
        Option(data)
          .map((d) => d.filter((x) => x.id === e.target.value))
          .map(first)
          .fold(noop, setSelected);
      }}
      options={data.map(({ id, launchName }) => ({
        title: launchName,
        value: id,
      }))}
    />
  );
};
